/* @flow */
import Entity from 'lib/Entity';
import apiRequest from 'lib/apiRequest';
import Group from 'entities/Group';

import _ from 'lodash';

class Subscription extends Entity {
  initialize() {
    this.urlRoot = '/subscriptions';
  }

  parse(response: Object) {
    const subscription = _.clone(response);
    subscription['group'] = Group.fromJSON(subscription['group']);
    subscription['subscribed_at'] = new Date(subscription['subscribed_at']);
    return subscription;
  }

  getSubscriberId() {
    return this.get('subscriber_id');
  }

  /**
   * @deprecated
   */
  getGroup() {
    // DIRTY HACK around cyclic dependency
    // Problem: entities calling out to stores
    // Deeper problem: nested models
    // Real solution: normalize models and pull by id from stores when needed
    const GroupStore = require('groups/stores/GroupStore').default;
    const group = GroupStore.getGroup(this.getGroupId());
    if (group) {
      return group;
    } else {
      return this.get('group');
    }
  }

  getGroupId() {
    return this.get('group').id;
  }

  getSubscribedAt() {
    return this.get('subscribed_at');
  }

  toJSON() {
    const json = super.toJSON();
    json['group'] = this.getGroup().toJSON();
    return json;
  }

  static initiateDeviceSubscription(groupCode, recipient) {
    return apiRequest(`/subscribe/${groupCode}`, 'POST', {
      recipient,
    });
  }
}

export default Subscription;



// WEBPACK FOOTER //
// ./src/entities/Subscription.js